import ChipRow from "./chip-row";

// Shares the `.mood` slide-up sheet styling; Mood was just its first user.
// Pitch Lock and Fast Control moved out of here to pills under Slow Control
// (./slow-control-section.jsx), as Slowed Studio shows them.
export default function HelpSheet({
  open,
  isProFeaturesLocked,
  onChangelogClick,
  onShortcutsClick,
  // Safari has no page to set an extension's shortcuts on.
  canCustomizeShortcuts = true,
}) {
  const locked = !!isProFeaturesLocked;

  const items = [
    // Hidden while locked, as it was in the bottom bar: most commands toggle
    // Pro effects. An action, not a toggle, so it never reads as pressed.
    ...(locked || !canCustomizeShortcuts
      ? []
      : [
          {
            key: "shortcuts",
            label: "Shortcuts",
            title: "Set keyboard shortcuts for Slowed",
            action: true,
            onClick: () => onShortcutsClick?.(),
          },
        ]),
  ];

  return (
    <div
      id="mood-sheet"
      className={`mood mood--help${open ? " mood--open" : ""}`}
      aria-label="Advanced"
      aria-hidden={!open}
      {...(!open ? { inert: true } : {})}
    >
      <div className="mood__header">
        <div className="mood__title-row">
          <div className="content__title">Advanced</div>
          <button
            type="button"
            className="mood__version"
            onClick={() => onChangelogClick?.()}
            title="See what is new in this version"
            tabIndex={open ? 0 : -1}
          >
            {`v${process.env.VERSION}`}
          </button>
        </div>
        <p className="mood__subtitle">
          {items.length
            ? "Keyboard shortcuts, and what is new in this version."
            : "See what is new in this version."}
        </p>
      </div>

      {items.length > 0 && (
        <ChipRow>
          {items.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`mood__chip${item.selected ? " mood__chip--selected" : ""}${
                item.locked ? " mood__chip--locked" : ""
              }`}
              onClick={() => item.onClick?.()}
              title={item.title || item.label}
              aria-disabled={item.locked || undefined}
              aria-pressed={item.action ? undefined : !!item.selected}
              tabIndex={open ? 0 : -1}
            >
              <span className="mood__chip-name">{item.label}</span>
            </button>
          ))}
        </ChipRow>
      )}
    </div>
  );
}
